export default "__VITE_ASSET__N1hoYFOw__"